import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

const BadgeGuard = ({ children }) => {
  const { badgedIn, isAuthenticated, badgedUser } = useAuth();

  if (!isAuthenticated) {
    return <Redirect to="/login" />;
  }  else
  if (badgedIn) {
    return <Redirect to="/app/processes" />
  } else
  return (
    <>
      {children}
    </>
  );
};

BadgeGuard.propTypes = {
  children: PropTypes.node
};

export default BadgeGuard;